import React, { FC, FunctionComponent, SVGProps } from "react";
import { Link, useNavigate } from "react-router-dom"
import { MenuItem } from "@mui/material"

import { useAppDispatch } from "@app/hooks.ts"
import { userLogout } from "@app/data/appTokensStore.ts"
import { logout } from "@/features/authorization_page/AuthorizationSlice.ts"

import { handleProfileItemStyle, sideMenuItem} from "./../HeaderProfileMenu/headerProfileMenuStyles"

type IconProfileMenuItem = {
  icon?: FunctionComponent<SVGProps<SVGSVGElement>>
  alt: {
    ru: string
    en: string
  }
  path?: string
  text?: string
}

export type HeaderProfileItemProps = {
  item: IconProfileMenuItem
  i: number
  isOpenMenu: boolean
}

const HeaderProfileItem: FC<HeaderProfileItemProps> = ({ item, i, isOpenMenu }) => {
  const { path, icon: Icon, text } = item || {}
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  if (!path || !Icon || !text) {
    return null
  }

  const handleItemClick = () => {
    if (path === "/") {
      dispatch(logout())
      dispatch(userLogout())
      !isOpenMenu
    } else {
      navigate(path, { replace: true })
      !isOpenMenu
    }
  }

  return (
    <Link
      to={path}
      key={text}
      style={handleProfileItemStyle(i, isOpenMenu)}
      onClick={handleItemClick}
    >
      <MenuItem sx={sideMenuItem}>
        <Icon/>
        {text}
      </MenuItem>
    </Link>
  )
}

export default HeaderProfileItem
